import { render, staticRenderFns } from "./parkingAreaSelect2.vue?vue&type=template&id=9635ae6a"
import script from "./parkingAreaSelect2.vue?vue&type=script&lang=js"
export * from "./parkingAreaSelect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports